/* ak-scroll.js — F9.
   (1) LEFT PAGE + POSITION INDICATOR: page dots are server-rendered links in #ak-rail; this script adds one position dot per section
       ([data-sec]) or, when a page has none, one per screen of content. Clicking a position dot glides there.
   (2) Scroll-linked fade-out: text and cards ease out as they leave through the top (nothing drags or sticks).
   (3) Smooth cut-offs: sections feather in; reduced motion = no fade.
   Nothing is hidden if this script does not run. */
(function () {
  'use strict';
  var d = document.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var main = document.getElementById('MainContent');

  /* ---------- 1. position dots ---------- */
  var rail = document.getElementById('ak-rail'), posBox = document.getElementById('ak-rail-pos');
  var dots = [], targets = [], mode = 'screens';
  function build() {
    if (!posBox) return;
    var secs = main ? Array.prototype.slice.call(main.querySelectorAll('[data-sec]')) : [];
    var vh = window.innerHeight, h = d.scrollHeight, n;
    if (secs.length >= 2) { mode = 'sections'; targets = secs; n = secs.length; }
    else { mode = 'screens'; n = Math.max(1, Math.min(7, Math.ceil(h / vh))); targets = []; }
    posBox.innerHTML = ''; dots = [];
    posBox.style.display = n < 2 ? 'none' : '';
    for (var i = 0; i < n; i++) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ak-pos'; b.setAttribute('aria-label', 'Position ' + (i + 1));
      (function (k) { b.addEventListener('click', function () { goTo(k); }); })(i);
      posBox.appendChild(b); dots.push(b);
    }
    place();
  }
  function goTo(k) {
    var y;
    if (mode === 'sections' && targets[k]) y = targets[k].getBoundingClientRect().top + window.pageYOffset - (k === 0 ? 0 : window.innerHeight * 0.12);
    else y = (d.scrollHeight - window.innerHeight) * (k / Math.max(1, dots.length - 1));
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
  }
  var curDot = -1;
  function place() {
    if (!dots.length) return;
    var vh = window.innerHeight, y = window.pageYOffset, max = d.scrollHeight - vh, k = 0;
    if (mode === 'sections') {
      for (var i = 0; i < targets.length; i++) { if (targets[i].getBoundingClientRect().top <= vh * 0.55) k = i; }
      if (max > 0 && y >= max - 4) k = targets.length - 1;
    } else {
      k = max > 0 ? Math.round(y / max * (dots.length - 1)) : 0;
    }
    if (k === curDot) return;
    curDot = k;
    dots.forEach(function (b, i) { b.classList.toggle('is-on', i === k); b.classList.toggle('is-near', Math.abs(i - k) === 1); });
  }

  /* ---------- 2. fade-out on scroll ---------- */
  var items = [];
  if (main && !reduce) {
    var TEXT = 'h1:not(.ak-sr),h2,h3,p,li,.sec-link,.soul-b,.contact-pills > *,.cart-row,.pdp-option,.newsletter-form,.sec-more,.reveal-box,.lb-ghosts';
    var BOX = '[data-reveal],.hero-content,.strip,.hp-item,.glass-panel';
    var skip = '.shop-side,.cart-drawer,.lb-viewer,.reveal-panel';
    var boxes = Array.prototype.filter.call(main.querySelectorAll(BOX), function (el) { return !el.closest(skip); });
    var boxSet = new Set(boxes);
    var inBox = function (el) { for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) { if (boxSet.has(p)) return true; } return false; };
    var texts = Array.prototype.filter.call(main.querySelectorAll(TEXT), function (el) { return !boxSet.has(el) && !inBox(el) && !el.closest(skip); });
    boxes.concat(texts).forEach(function (el) { if (el.classList.contains('hero-content')) return; el.setAttribute('data-fade', ''); items.push({ el: el, cur: 1, t: 1, last: -1 }); });
  }
  var raf = 0;
  function smooth(x) { return x * x * (3 - 2 * x); }
  function frame() {
    raf = 0;
    var vh = window.innerHeight, moving = false, i, it, r;
    for (i = 0; i < items.length; i++) {
      it = items[i]; r = it.el.getBoundingClientRect();
      if (r.bottom < -40) it.t = 0;
      else if (r.top > vh) it.t = 1;
      else { var lo = vh * 0.02, hi = vh * 0.18, k = (r.bottom - lo) / (hi - lo); it.t = smooth(k < 0 ? 0 : k > 1 ? 1 : k); }
    }
    for (i = 0; i < items.length; i++) {
      it = items[i];
      var diff = it.t - it.cur;
      if (Math.abs(diff) < 0.004) it.cur = it.t; else { it.cur += diff * 0.22; moving = true; }
      if (Math.abs(it.cur - it.last) > 0.003 || (it.cur === it.t && it.last !== it.cur)) { it.el.style.setProperty('--fo', it.cur.toFixed(3)); it.last = it.cur; }
    }
    if (moving) raf = requestAnimationFrame(frame);
  }

  /* ---------- 3. reveal toggles (Soul, Terms, product details) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-toggle]') : null;
    if (!b) return;
    var box = b.closest('.reveal-box'); if (!box) return;
    var open = !box.classList.contains('is-open');
    box.classList.toggle('is-open', open);
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  function onScroll() { if (!raf && items.length) raf = requestAnimationFrame(frame); place(); }
  var rt = 0;
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { curDot = -1; build(); onScroll(); }, 150); });
  window.addEventListener('load', function () { curDot = -1; build(); onScroll(); });
  build();
  if (items.length) frame();
  if (rail) rail.classList.add('is-ready');
})();
